import CampaignBadge from './CampaignBadge.container'

export default CampaignBadge
